import React from "react";
import Contract from "./components/Contract";

const ContractPreview = ({ onClose, type }) => {
  return (
    <>
     <Contract />
    </>
  );
};

export default ContractPreview;
